import { Alert, AlertDescription, AlertTitle, Button } from "@diametral/design-system/react";

import { Trans, useTranslation } from "../lib/i18n";

/** Keycloak could not be reached at startup: nothing else can work, say so plainly. */
export function BootError({ keycloakUrl }: { keycloakUrl: string }) {
  const { t } = useTranslation();
  return (
    <main className="ada-full-screen">
      <div className="ada-stack">
        <Alert tone="danger">
          <AlertTitle>{t("Authentication unavailable")}</AlertTitle>
          <AlertDescription>
            <Trans
              i18nKey="The authentication server is not responding (<code>{{url}}</code>). Try again in a moment; if the problem persists, let the ada team know."
              values={{ url: keycloakUrl }}
              components={{ code: <code className="ada-mono" /> }}
            />
          </AlertDescription>
        </Alert>
        <div>
          <Button variant="primary" onClick={() => window.location.reload()}>
            {t("Try again")}
          </Button>
        </div>
      </div>
    </main>
  );
}
